import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var Keyboard = React.forwardRef(function (props, ref) {
    var customisedCls = props.prefixCls, className = props.className, children = props.children, otherProps = __rest(props, ["prefixCls", "className", "children"]);
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('kbd', configContext.prefixCls, customisedCls);
    var cls = classNames(prefixCls, className);
    return (React.createElement("kbd", __assign({}, otherProps, { ref: ref, className: cls }), children));
});
Keyboard.displayName = 'Keyboard';
export default Keyboard;
//# sourceMappingURL=index.js.map